import React, { useEffect } from "react";
import { LoginContextData } from "../Declarations";
import { useQuery } from "@tanstack/react-query";
import { createAxiosClient } from "@ntg/component-library/utilities";

interface Props {
    data: LoginContextData;
    onDecision: (requires2FA: boolean) => void;
}

export const Check2FARequired = ({ data, onDecision }: Props) => {
    const axiosAuth = createAxiosClient("Auth");

    const query = useQuery({
        enabled:
            data.UserName !== undefined &&
            data.Password !== undefined &&
            data.UserID !== undefined &&
            data.BrowserFingerprint !== undefined,
        queryFn: async (): Promise<boolean> => {
            const res = await axiosAuth.post<boolean>(
                "/UILogin/Requires2FAVerification",
                {
                    BrowserFingerPrint: data.BrowserFingerprint,
                    Password: data.Password,
                    UserAgent: navigator.userAgent,
                    UserID: data.UserID,
                    UserName: data.UserName,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            return res.data;
        },
        queryKey: [
            "check2faRequired",
            data.UserName,
            data.Password,
            data.UserID,
            data.BrowserFingerprint,
        ],
    });

    useEffect(() => {
        if (query.isSuccess) {
            onDecision(query.data);
        }
    }, [query.isSuccess, query.data, onDecision]);

    if (query.isLoading) {
        return <p>Checking if 2FA is required...</p>;
    }

    if (query.isError) {
        return <p className="error">Unable to determine 2FA requirement.</p>;
    }

    return null;
};
